var exports = {
  "vi": "CheckboxesElementGroup__vDIvrh",
  "r6": "CheckboxesElementGroupLabel__anw0J9",
  "jC": "CheckboxesElementGroupDescription__VJTnPV",
  "HV": "checkboxOptionLabel__oO4t3R",
};

module.exports = exports;
